<template>
  <div>
    <form :id="formId">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.username')}}:</div>
              <ejs-dropdownlist id='accounts' refs="accounts" :dataSource='accountData' :index="selectIndex" :fields='accountField'
                            :placeholder="$t('Security.selectAccount')" :change="changeAccount"></ejs-dropdownlist>
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.client.addresses')}}:</div>
              <input
                class="e-input e-input-group"
                :id="this.baseType+'addresses'"
                name="addresses"
                v-model="addresses"
                maxlength="60"
                :placeholder="$t('Security.client.addresses')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: "accountOption",
    props: {
      baseType: String
    },
    data() {
      return {
        formId: this.baseType+'accForm',
        accountData: [],
        selectIndex: '',
        id: '',
        accountId: '',
        accountName: '',
        addresses: '',
        accountField: {
          text: 'username',
          value: 'userId'
        }
      }
    },
    mounted() {
    },
    methods: {
      init(id, accountId) {
        const url = '/lte/ems/user/findAccountList';
        const That = this;
        this.axios.get(url, {}).then(response => {
          let accountList = response.data;
          That.selectAccount(accountId);
          if (!!id) {
            That.accountData = accountList;
            That.selectAccount(accountId)
          } else {
            That.axios.get('/lte/ems/client/findAccountBind', {}).then(res => {
              if (!!res.data) {
                for (let index=0; index<res.data.length; index++) {
                  let flag = false;
                  let i_p = 0;
                  for (let i=0; i<accountList.length; i++) {
                    if (accountList[i].userId == res.data[index]) {
                      i_p = i;
                      flag = true;
                      break
                    }
                  }
                  if (flag) {
                    accountList.splice(i_p, 1);
                  }
                }
                That.accountData = accountList;
              }
            })
          }
        });
        if (!!id) {
          const url = '/lte/ems/client/findAccountIPById';
          this.id = id;
          let That = this;
          this.axios.get(url, {params: {id: id}}).then(response => {
            const result = response.data;
            That.accountId = result.accountId;
            That.accountName = result.accountName;
            That.addresses = result.addresses;
          });
        }
      },
      validation() {
        this.setError('accounts', `${this.$t('Security.validate.chooseUser')}`, 'off');
        this.setError(this.baseType+'addresses', `${this.$t('Security.validate.ipError')}`, 'off');
        // 验证IP地址
        let result = this.accountId.trim()==''?false:true;
        if (!result) {
          this.setError('accounts', `${this.$t('Security.validate.chooseUser')}`, 'on');
        }
        //IPV4正则
        let regex = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        //IPV6正则
        let regexIPV6 = /^\s*((([0-9A-Fa-f]{1,4}:){7}(([0-9A-Fa-f]{1,4})|:))|(([0-9A-Fa-f]{1,4}:){6}(:|((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})|(:[0-9A-Fa-f]{1,4})))|(([0-9A-Fa-f]{1,4}:){5}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){4}(:[0-9A-Fa-f]{1,4}){0,1}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){3}(:[0-9A-Fa-f]{1,4}){0,2}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:){2}(:[0-9A-Fa-f]{1,4}){0,3}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(([0-9A-Fa-f]{1,4}:)(:[0-9A-Fa-f]{1,4}){0,4}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(:(:[0-9A-Fa-f]{1,4}){0,5}((:((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})?)|((:[0-9A-Fa-f]{1,4}){1,2})))|(((25[0-5]|2[0-4]\d|[01]?\d{1,2})(\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})){3})))(%.+)?\s*$/;
        let adds = this.addresses.split(';')
        for(let i=0; i<adds.length; i++) {
          if(adds[i].indexOf(':') !=-1){//判断IP是IPV4还是IPV6
            if (!regexIPV6.test(adds[i])) {//IPV6分支
              this.setError(this.baseType+'addresses', `${this.$t('Security.validate.ipError')}`, 'on');
              result = false;
              break;
            }
          }else{//IPV4分支
            if (!regex.test(adds[i])) {//IPV6分支
              this.setError(this.baseType+'addresses',`${this.$t('Security.validate.ipError')}`, 'on');
              result = false;
              break;
            }
          }
        }
        return result;
      },
      getParam() {
        return {
          id: this.id,
          accountId: this.accountId,
          accountName: this.accountName,
          addresses: this.addresses
        }
      },
      changeAccount(args) {
        this.accountId = args.itemData.userId
        this.accountName = args.itemData.username
      },
      selectAccount(accountId) {
        for (let i = 0; i < this.accountData.length; i++) {
          if (this.accountData[i].userId==accountId) {
            this.selectIndex = i
            break;
          }
        }
      },
      setError(id, text, status) {
        if (status=='on') {
          let error_info = document.createElement("label");
          error_info.setAttribute('for', id);
          error_info.className = 'e-error';
          error_info.innerHTML = text;
          error_info.style.display = "block";
          document.getElementById(id).closest('.form-group').querySelector('.error').parentElement.appendChild(error_info);
        } else {
          let enode = document.getElementById(id).closest('.form-group').querySelector('.e-error');
          if (enode) {
            enode.remove();
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
